<template>
  <VView class="gallery" back-button-to="/menu" header="Galeria">
    <ul class="gallery__grid">
      <li class="gallery__item" v-for="(entry, entryIndex) in entries" :key="entryIndex">
        <VBlock class="gallery__frame" @click.native="$router.push(`/gallery/${entry._id}`)">
          <img :src="entry.result.attachment" />
        </VBlock>

        <!-- <VText small center>{{ entry.firstName }}</VText> -->
      </li>
    </ul>
  </VView>
</template>

<script>
export default {
  name: 'Gallery',

  data: () => ({
    entries: [],
    pages: [],
  }),

  async mounted() {
    const { data: entries } = await this.$bricodes.getPublicEntries();

    this.entries = entries.filter(entry => entry.isConfirmed && !entry.isFavorite).reverse();
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  &__grid {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__item {
    flex: 1 1 33.3333%;
    max-width: 33.3333%;
    padding: 13px 18px;

    @media screen and (max-width: 800px) {
      flex: 1 1 50%;
      max-width: 50%;
    }

    @media screen and (max-width: 550px) {
      flex: 1 1 100%;
      max-width: 100%;
    }

    ::v-deep .text {
      margin-top: -10%;
      font-size: 20px;
      line-height: 1.25em;
    }
  }

  &__frame {
    cursor: pointer;
    transition: transform 0.25s ease-in-out;

    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>
